
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dwrNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fcd686047d542e8$export$2e2bcd8739ae039);
/*
 * This a dummy file for when our synchronous renderer nodes feature gates are disabled
 * This file is the conditional import fallback to use when a respective node group's feature gate is false
 *
 * This file is duplicated due to (at the time of writing) conditional imports needing to be pointed to unique files: https://atlassian.slack.com/archives/C07SP6N4FD5/p1748324594958659?thread_ts=1748311964.968589&cid=C07SP6N4FD5
 * When that is fixed, usages of this file should use emptyRendererNodeMapping.tsx instead
 */ const $0fcd686047d542e8$var$emptyRendererNodeMapping3 = {};
var $0fcd686047d542e8$export$2e2bcd8739ae039 = $0fcd686047d542e8$var$emptyRendererNodeMapping3;

});


$parcel$global.rlb("f771T")
//# sourceMappingURL=emptyRendererNodeMapping3.eea7fb7e.js.map
